export const VesselIcon = ({ color = "#0F2C52" }: { color?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1592_3312)">
        <path
          d="M0.625 19.3859C1.3037 19.4699 1.99259 19.4012 2.64137 19.185C3.29015 18.9687 3.88244 18.6103 4.375 18.1359C4.73027 18.5294 5.16416 18.8439 5.64863 19.0593C6.13309 19.2746 6.65735 19.3858 7.1875 19.3858C7.71765 19.3858 8.24191 19.2746 8.72637 19.0593C9.21084 18.8439 9.64473 18.5294 10 18.1359C10.3553 18.5294 10.7892 18.8439 11.2736 19.0593C11.7581 19.2746 12.2823 19.3858 12.8125 19.3858C13.3427 19.3858 13.8669 19.2746 14.3514 19.0593C14.8358 18.8439 15.2697 18.5294 15.625 18.1359C16.1176 18.6103 16.7099 18.9687 17.3586 19.185C18.0074 19.4012 18.6963 19.4699 19.375 19.3859"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.921875 15.6359H19.2769"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5616 17.04C19.3749 16.0725 19.3741 15.3934 19.3716 13.8175C19.3795 13.6435 19.3218 13.4727 19.2099 13.3392C19.1512 13.2752 19.0799 13.224 19.0004 13.189C18.921 13.154 18.8351 13.1359 18.7482 13.1359H9.0399C8.82034 13.136 8.60462 13.0783 8.41444 12.9686C8.22427 12.8589 8.06634 12.701 7.95656 12.5109C7.84679 12.3207 7.68886 12.1628 7.49868 12.0531C7.30851 11.9434 7.09279 11.8857 6.87323 11.8859H1.24906C1.16222 11.8859 1.07634 11.904 0.996867 11.939C0.917392 11.974 0.846061 12.0252 0.787397 12.0892C0.675448 12.2227 0.617748 12.3935 0.62573 12.5675C0.62573 14.1917 0.62573 15.8617 1.67073 16.9317"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.875 8.13586V10.6359"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.29167 3.13586H8.95833C9.06884 3.13586 9.17482 3.17976 9.25296 3.2579C9.3311 3.33604 9.375 3.44202 9.375 3.55253V6.88586H6.875V3.55253C6.875 3.44202 6.9189 3.33604 6.99704 3.2579C7.07518 3.17976 7.18116 3.13586 7.29167 3.13586Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.625 9.38586H8.125"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.625 1.26079C15.0996 1.69535 14.431 1.91822 13.75 1.88579C11.75 1.88579 12 0.635791 10 0.635791C9.31898 0.603364 8.65036 0.826235 8.125 1.26079"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.125 13.1359V11.8859C18.125 11.5543 17.9933 11.2364 17.7589 11.002C17.5245 10.7676 17.2065 10.6359 16.875 10.6359H13.125C12.9608 10.6359 12.7983 10.6035 12.6466 10.5407C12.495 10.4779 12.3572 10.3858 12.2411 10.2697C12.125 10.1537 12.033 10.0159 11.9702 9.86422C11.9073 9.71256 11.875 9.55002 11.875 9.38586C11.875 8.72282 11.6116 8.08694 11.1428 7.6181C10.6739 7.14926 10.038 6.88586 9.375 6.88586H6.875C6.54348 6.88586 6.22554 7.01756 5.99112 7.25198C5.7567 7.4864 5.625 7.80434 5.625 8.13586V11.8859"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.375 8.13586V10.6359"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.541 8.13586H18.1252"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1592_3312">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
